export default __webpack_public_path__ + "static/media/bet6.5e4467fd.png";